import type { ThemeConfig } from 'antd';
import type { LooseObjectType, BrandCodeType } from 'utils/globalTypes';
import { BRAND_CODES } from 'brand-config';
import { defaultConfig, defaultVariables } from 'theme/default';
import { privacyConfig, privacyVariables } from 'theme/privacy';
import { psmsConfig, psmsVariables } from 'theme/psms';
import { mgsafeConfig, mgsafeVariables } from 'theme/mgsafe';
import { dshopConfig, dshopVariables } from 'theme/dshop';
import { dsafeConfig, dsafeVariables } from 'theme/dsafe';
import { partyhatConfig, partyhatVariables } from 'theme/partyhat';
import { protectivConfig, protectivVariables } from 'theme/protectiv';
import { phSafeConfig, phSafeVariables } from 'theme/phsafe';
import { iddefenseConfig, iddefenseVariables } from 'theme/iddefense';

type BrandThemeConfig = {
  config: ThemeConfig;
  variables: LooseObjectType;
};

export type BrandThemeConfigType = Record<
  BrandCodeType | 'default',
  BrandThemeConfig
>;

const BRAND_THEME_CONFIG: BrandThemeConfigType = {
  [BRAND_CODES.privacyShield]: {
    config: privacyConfig,
    variables: privacyVariables,
  },
  [BRAND_CODES.privacyMedicalShield]: {
    config: psmsConfig,
    variables: psmsVariables,
  },
  [BRAND_CODES.missGroupSafe]: {
    config: mgsafeConfig,
    variables: mgsafeVariables,
  },
  [BRAND_CODES.domeneShop]: {
    config: dshopConfig,
    variables: dshopVariables,
  },
  [BRAND_CODES.domainkeskusSafe]: {
    config: dsafeConfig,
    variables: dsafeVariables,
  },
  [BRAND_CODES.partyhat]: {
    config: partyhatConfig,
    variables: partyhatVariables,
  },
  [BRAND_CODES.protectIV]: {
    config: protectivConfig,
    variables: protectivVariables,
  },
  [BRAND_CODES.phSafe]: {
    config: phSafeConfig,
    variables: phSafeVariables,
  },
  [BRAND_CODES.identityDefense]: {
    config: iddefenseConfig,
    variables: iddefenseVariables,
  },
  default: {
    config: defaultConfig,
    variables: defaultVariables,
  },
};

export default BRAND_THEME_CONFIG;
